import moment from 'moment';
import { formatAmount, formatCount, formatRate, getRateOfTotal } from '../lib';
import { LenderActivityFilterFormValues, LenderAppsSorting, SummaryCardConfig } from '../types';

export const LENDER_ACTIVITY_DEFAULT_FILTERS: LenderActivityFilterFormValues = {
  from: moment().startOf('year'),
  to: moment().endOf('year'),
};

export const LENDER_APPS_DEFAULT_SORTING: LenderAppsSorting = {
  key: 'approvedAmount',
  value: 'desc',
};

export const SUMMARY_CARDS: SummaryCardConfig[] = [
  {
    title: 'Credit Apps (Unique)',
    getValue: metrics => metrics.creditApps,
    format: formatCount,
  },
  {
    title: 'Credit Apps (Amount requested)',
    getValue: metrics => metrics.requestedAmount,
    format: formatAmount,
  },
  {
    title: 'Lender Apps (Each Submission)',
    getValue: metrics => metrics.syndications,
    format: formatCount,
  },
  {
    title: 'Credit App (Approval Rate)',
    getValue: metrics => getRateOfTotal(metrics.approvedApps, metrics.submittedApps /* metrics.creditApps */),
    format: formatRate,
    valueColor: 'success.main',
  },
  {
    title: 'Approved Credit Apps',
    getValue: metrics => metrics.approvedApps,
    format: formatCount,
  },
  {
    title: 'Funded Credit Apps',
    getValue: metrics => metrics.fundedSubmissions,
    format: formatCount,
  },
];
